import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import JsonData from "../data/data.json";
import { Footer } from "./footer";

export const ServiceDetails = (props) => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const service = JsonData.ServiceDetails.find((s) => s.slug === slug);
  
  const handleNav = (hash) => (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate({ pathname: "/", hash });
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100); // Increased timeout
    } else {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
      window.history.pushState(null, "", hash);
    }
  };
  // Use images from data, fallback to img if images not available
  const carouselImages = service?.images || (service?.img ? [service.img] : []);

  // Scroll to top when component mounts or slug changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  // Auto-rotate carousel every 3.5 seconds
  useEffect(() => {
    if (carouselImages.length === 0) return;
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % carouselImages.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [carouselImages.length]);
  if (!service) {
    return (
      <div style={{ padding: "200px 20px", textAlign: "center" }}>
        <h1>Service Not Found</h1>
        <p>Sorry, the service you're looking for doesn't exist.</p>
      </div>
    );
  }

  return (
    <div>
      {/* Hero Section */}
      <div className="service-details-hero">
        <div className="overlay"></div>
        <div className="container">
          <h1 className="service-details-title">{service.title}</h1>
          {/* <p className="service-details-subtitle">{service.text.description}</p> */}
        </div>
      </div>

      {/* Main Content */}
      <div className="service-details-container">
        <div className="container">
          <div className="row">
            {/* Main Content Column */}
            <div className="col-md-8">
              <div className="service-details-content">
                {/* Carousel */}
                <div className="service-carousel">
                  <div className="carousel-wrapper">
                    {carouselImages.map((img, i) => (
                      <div
                        key={i}
                        className={`carousel-slide ${i === currentImageIndex ? "active" : ""}`}
                      >
                        <img
                          src={`${process.env.PUBLIC_URL}/${img}`}
                          alt={`${service.title} - Slide ${i + 1}`}
                          className="img-responsive"
                          onError={(e) => {
                            e.target.src = "https://via.placeholder.com/700x400?text=Service+Image";
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="service-details-section">
                  <h2>{service.text.bulletpointHeader}</h2>
                  <ul className="service-details-list">
                    {service.text.bulletPoints.map((point, i) => (
                      <li key={i}>
                        <i className="fa fa-check-circle"></i>
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

           { /* Sidebar */}
                  <div className="col-md-4">
                    <div className="service-details-sidebar">
                    <div className="sidebar-card">
                      <h4>Quick Info</h4>
                      <p>
                      {service.text.description}
                      </p>
                    </div>

                    <div className="sidebar-card">
                      <h4>Get In Touch</h4>
                      <p>Need more information? Contact our team for detailed guidance.</p>
                      <a href="/#contact" className="btn btn-custom" onClick={handleNav('#contact')}>
                      Contact Us
                      </a>
                    </div>

                    <div className="sidebar-card related-services">
                      <h4>More Services</h4>
                      <ul>
                      {JsonData.Services.filter((s) => s.name.toLowerCase().replace(/\s+/g, "-") !== slug).map((s, i) => {
                        const relatedSlug = s.name.toLowerCase().replace(/\s+/g, "-");
                        return (
                        <li key={i}>
                          <a href={`/service/${relatedSlug}`}>
                          <i className="fa fa-arrow-right"></i> {s.name}
                          </a>
                        </li>
                        );
                      })}
                      </ul>
                    </div>
                    </div>
                  </div>
                  </div>
                </div>
                </div>

                {/* CTA Section */}
      <div className="service-details-cta">
        <div className="container text-center">
          <h2>Ready to get started?</h2>
          <p>Explore how {service.title} can transform your business.</p>
          <a href="/#contact" className="btn btn-custom btn-lg" onClick={handleNav('#contact')}>
            Request a Quote
          </a>
        </div>
      </div>

      <Footer data={props.data} />
    </div>
  );
};
